/** 能源 — 分表计量 /energy/sub-metering（subMetering.vue + TreeNode.vue） */
export default {
  subMeteringPage: {
    emptyNoViewPermission: '暂无查看权限',
    phSearchKeyword: '搜索节点名称 / 序列号…',
    phDateStart: '开始日期',
    phDateEnd: '结束日期',
    titleUndo: '撤销排序/移动（最多5步）',
    btnUndo: '撤销',
    titleRefresh: '刷新拓扑数据',
    btnRefresh: '刷新',
    msgSankeyDev: '桑基图功能开发中',
    btnSankey: '桑基图',
    titleZoomOut: '缩小',
    titleZoomIn: '放大',
    titleResetView: '重置视图',
    emptyNoTopology: '暂无拓扑数据',
    btnCreateRoot: '创建根节点',
    titleClosePanel: '关闭',
    dateRangeTo: '至',
    altMeter: '电表',
    altMainMeter: '主表',
    altBackupMeter: '备表',
    ehcLabelTotalEnergy: '区间总用能',
    childEnergyTitle: '下级节点用能',
    childCountLabel: '共 {n} 个节点',
    labelPrimaryShort: '主',
    labelBackupShort: '备',
    labelPrimary: '主',
    labelBackup: '备',
    labelCategoryNode: '分类节点',
    labelDualPower: '双电源',
    labelDualPowerNode: '双电源节点',
    emptyNoChildren: '暂无子节点，右键可添加',
    chartDailyTrend: '日电量趋势',
    chartUnitKwh: '电量（kWh）',
    chartLegendTotal: '总电量',
    emptyNoDailyData: '暂无日电量数据',
    statPeakDaily: '峰值日用能',
    statAvgDaily: '日均用能',
    statLossRate: '线损率',
    statDeviceCount: '设备数量',
    unitDevice: '台',
    sectionUpstreamMeter: '上级电表',
    linkViewDetail: '查看详情',
    linkView: '查看',
    labelMainMeter: '主用表',
    labelBackupMeter: '备用表',
    labelLossRateInline: '线损率',
    ratioPrefix: '占比',
    tagCurrentNode: '当前节点',
    labelTotalEnergy: '总用能 {v} kWh',
    labelRealtimePower: '实时功率 {v} kW',
    dualSepBackup: '备用表',
    sectionDownstreamMeter: '下级电表',
    draggingMoving: '正在移动：',
    dlgBindMeter: '绑定电表',
    dlgBindDual: '绑定电表（双电源）',
    dualDlgAlert: '请勾选两个电表作为双电源节点的主备表（第一个为主表，第二个为备用表）',
    phMeterSearch: '序列号 / 名称搜索',
    colSerial: '序列号',
    colMeterName: '设备名称',
    colMeterType: '电表类型',
    colOnlineStatus: '在线状态',
    btnConfirmBind: '确认绑定',
    btnOk: '确定',
    btnCancel: '取消',
    dualSelectedPrefix: '已选 {n}/2：',
    dlgLayerSettings: '层级设置',
    formLayerName: '层级名称',
    phLayerName: '请输入层级名称',
    btnConfirmAdd: '确认添加',
    virtualRootName: '项目根节点',
    nodeTypeRoot: '根节点',
    nodeTypeCategory: '分类节点',
    nodeTypeDual: '双电源设备',
    nodeTypeDevice: '设备节点',
    treeExpand: '展开',
    treeCollapse: '折叠',
    treeExpandChildren: '展开 {n} 个节点',
    treeExpandHidden: '展开 {n} 个隐藏节点',
    placeholderChildDevice: '子设备{n}',
    meterBind_1: '专用表',
    meterBind_2: '公摊表',
    meterBind_3: '公式表',
    meterBind_4: '空调表',
    meterOnline_0: '离线',
    meterOnline_1: '在线',
    msgNoControl: '暂无控制权限',
    msgFetchTreeFail: '获取拓扑树失败，请重试',
    msgLoadMeterListFail: '加载电表列表失败',
    ctxAddRoot: '添加根节点',
    ctxAddCategory: '创建子分类',
    ctxBindMeter: '绑定电表',
    ctxBindDual: '绑定电表(双电源)',
    ctxRename: '修改名称',
    ctxDelete: '删除节点',
    ctxUnbind: '解绑此表',
    promptAddCatTitle: '创建子分类',
    promptAddCatMessage: '请输入子分类名称',
    promptRenameTitle: '修改',
    promptRenameMessage: '修改名称',
    inputErrorNameRequired: '名称不能为空',
    msgCreateSuccess: '创建成功：{name}',
    msgCreateFail: '创建失败',
    msgCreateFailRetry: '创建失败，请重试',
    msgRenameSuccess: '修改成功',
    msgRenameFail: '修改失败',
    msgRenameFailRetry: '修改失败，请重试',
    titleWarning: '警告',
    confirmDeleteWithChildren: '确认删除【{name}】及其所有子节点？',
    confirmUnbind: '确认解绑【{name}】？',
    msgDeleteSuccess: '删除成功',
    msgUnbindSuccess: '解绑成功',
    msgDeleteFail: '删除失败',
    msgUnbindFail: '解绑失败',
    msgOpFailRetry: '操作失败，请重试',
    msgPickTwoMeters: '请选择两个电表（主表和备用表）',
    msgBindDualSuccess: '已绑定双电源',
    msgBindFail: '绑定失败',
    msgBindFailRetry: '绑定失败，请重试',
    msgPickAtLeastOneMeter: '请至少选择一个电表',
    msgBindManySuccess: '已绑定 {n} 个电表',
    msgBindPartial: '{ok} 个成功，{fail} 个失败',
    msgLayerNameRequired: '请输入层级名称',
    msgOnlyOneRoot: '最外层只允许一个根节点',
    msgLayerAdded: '层级已添加：{name}',
    msgAddFail: '添加失败',
    msgAddFailRetry: '添加失败，请重试',
    msgCannotMoveToDescendant: '不能移动到自身子节点下',
    msgMoveSuccess: '移动成功',
    msgMoveFail: '移动失败',
    msgMoveFailRetry: '移动失败，请重试',
    msgSortSuccess: '排序成功',
    msgOpFail: '操作失败',
    msgOpFailRetry2: '操作失败，请重试',
    msgUndoNone: '已无可撤销操作（最多 {max} 步）',
    msgUndoSyncing: '撤销中，同步 {n} 个节点…',
    msgUndoPartialFail: '撤销部分失败（{fail}/{total} 个节点同步失败）',
    msgUndoSuccess: '撤销成功',
    msgDailyEnergyFail: '获取日电量失败',
    msgDailyEnergyFailRetry: '获取日电量失败，请重试',
    msgDateSpanYear: '查询日期跨度不能超过 1 年，请重新选择',
    msgQueriedRange: '已查询 {start} 至 {end}',
    msgViewInfo: '查看：{name}'
  }
}
